module.exports = __webpack_public_path__ + "static/img/tool_04.9bfaba11.jpg";